import { useDataTableContext } from "../store/DataTableProvider";
import { DataTableStoreState } from "../store/DataTableProvider.types";
import { ModalEditTableBase } from "./ModalEditTableBase";

interface ModalEditDataTableProps {
  table: Extract<DataTableStoreState["tables"][number], { kind: "data" }>;
  onClose: () => void;
}

/** Component that renders a modal for updating a data table */
export const ModalEditDataTable = ({
  table,
  onClose,
}: ModalEditDataTableProps) => {
  const updateDataTable = useDataTableContext((s) => s.updateDataTable);

  return (
    <ModalEditTableBase
      table={table}
      onClose={onClose}
      onSubmit={(fields) => updateDataTable({ tableId: table.id, ...fields })}
    />
  );
};
